import _regeneratorRuntime from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import Transport from "@ledgerhq/hw-transport";
import { bip32asBuffer } from "./bip32";
import { MAX_SCRIPT_BLOCK } from "./constants";
export function provideOutputFullChangePath(transport, path) {
  var buffer = bip32asBuffer(path);
  return transport.send(0xe0, 0x4a, 0xff, 0x00, buffer);
}
export function hashOutputFull(_x, _x2) {
  return _hashOutputFull.apply(this, arguments);
}

function _hashOutputFull() {
  _hashOutputFull = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(transport, outputScript) {
    var additionals,
        offset,
        p1,
        isDecred,
        blockSize,
        _p,
        data,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            additionals = _args.length > 2 && _args[2] !== undefined ? _args[2] : [];
            offset = 0;
            p1 = 0x80;
            isDecred = additionals.includes("decred"); ///WARNING: Decred works only with one call (without chunking)
            //TODO: test without this for Decred

            if (!isDecred) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", transport.send(0xe0, 0x4a, p1, 0x00, outputScript));

          case 6:
            if (!(offset < outputScript.length)) {
              _context.next = 15;
              break;
            }

            blockSize = offset + MAX_SCRIPT_BLOCK >= outputScript.length ? outputScript.length - offset : MAX_SCRIPT_BLOCK;
            _p = offset + blockSize === outputScript.length ? 0x80 : 0x00;
            data = outputScript.slice(offset, offset + blockSize);
            _context.next = 12;
            return transport.send(0xe0, 0x4a, _p, 0x00, data);

          case 12:
            offset += blockSize;
            _context.next = 6;
            break;

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _hashOutputFull.apply(this, arguments);
}